import { Box } from '@mui/material';
import { Dispatch, SetStateAction, useEffect } from 'react';
import LearnerListRow from 'components/PurchaseProfiles/LearnerListRow/LearnerListRow';
import { LearnerForPurchase } from 'components/PurchaseProfiles/types';
import { shouldBlockPurchase } from 'components/PurchaseProfiles/LearnerListRow/helper';

type ProfileBasketProps = {
  purchaseItems: LearnerForPurchase[];
  removeCheckedItems?: (items: string[]) => void;
  evaluatorLinkOrganisationId?: string;
  evaluatorLinkId?: string;
  productName: string;
  setPurchaseError: Dispatch<SetStateAction<boolean>>;
  purchaseError: boolean;
  organisationIds: string[];
};

const ProfileBasket = ({
  purchaseItems,
  evaluatorLinkOrganisationId,
  evaluatorLinkId,
  removeCheckedItems,
  productName,
  setPurchaseError,
  purchaseError,
  organisationIds,
}: ProfileBasketProps) => {
  const blocked = shouldBlockPurchase({ productName, purchaseItems });

  useEffect(() => {
    if (blocked && !purchaseError) setPurchaseError(true);
    if (!blocked && purchaseError) setPurchaseError(false);
  }, [blocked, purchaseError, setPurchaseError]);

  return (
    <Box
      sx={{
        '& div': {
          marginLeft: '0 !important',
        },
        '& div:last-child': {
          marginBottom: '0',
        },
      }}
    >
      {purchaseItems.map((learner) => (
        <LearnerListRow
          key={learner.latestEvaluation.id}
          learner={learner}
          organisationId={learner.organisationId ?? organisationIds[0]}
          evaluatorLinkOrganisationId={evaluatorLinkOrganisationId}
          evaluatorLinkId={evaluatorLinkId}
          productName={productName}
          removeCheckedItem={
            removeCheckedItems
              ? (itemId) => removeCheckedItems([itemId])
              : undefined
          }
        />
      ))}
    </Box>
  );
};

export default ProfileBasket;
